

import React from "react";
import { useTranslations } from "next-intl";

type TCCCheckInStatusProps = {
  value: boolean | string | null | undefined;
};

export const TCCCheckInStatus: React.FC<TCCCheckInStatusProps> = React.memo(
  function TCCCheckInStatus({ value }) {
    const t = useTranslations("checkIn");

    // Three states from the nullable `checkedIn` boolean:
    //   true  → checked in, false → checked out,
    //   null/"" → never scanned ("offen" / not checked in).
    const checkedIn = value === true || value === "true";
    const checkedOut = value === false || value === "false";

    const { className, label } = checkedIn
      ? {
          className: "user-icon-font-4 user-icon-bg-4 outline-user-icon-4",
          label: t("actionCheckIn"),
        }
      : checkedOut
        ? {
            className: "user-icon-font-2 user-icon-bg-2 outline-user-icon-2",
            label: t("actionCheckOut"),
          }
        : {
            className: "font-secondary surface-tertiary outline-quaternary",
            label: t("notCheckedIn"),
          };

    return (
      <span
        className={`inline-flex items-center px-3 py-1 rounded-xl border body-3-medium ${className}`}
      >
        {label}
      </span>
    );
  },
);
